import React from "react";

const NoPage = () => {
    return (
      <>
        <div className="flex justify-center items-center h-screen">
          <div className="font-extrabold text-2xl">404 NO PAGE FOUND</div>
        </div>
      </>
    );
}

export default NoPage;